//CRN_20260508 - Riskline Local Risk Levels service (PULL via SureSim backend proxy)
//CRN_20260513 - https://riskline.readme.io/reference/apis-overview

import { catchError, Observable, of, throwError } from 'rxjs';
import { eSimApiPaths } from '../../consts';
import { environment } from 'src/environments/environment';
import { ExceptionsService } from '../utelize/general/exceptions-service';
import { HttpClientService } from '../utelize/general/http-client-service';
import { Injectable } from '@angular/core';
import { LocalRiskLevelRequestDTO, LocalRiskLevelResponseDTO } from '../../models/system/riskline/riskline-local-risk-level.dto';

@Injectable({ providedIn: 'root' })
export class RisklineLocalRiskLevelsService {

  constructor(
    private exceptionsService: ExceptionsService,
    private httpClientService: HttpClientService
  ) { }

  public getLocalRiskLevels(request: LocalRiskLevelRequestDTO): Observable<LocalRiskLevelResponseDTO> {
    try {
      if (!request || !request.places || request.places.length==0)
        throw new Error('RisklineLocalRiskLevelsService.getLocalRiskLevels() - request must contain at least one place');

      return this.httpClientService
             ._post<LocalRiskLevelResponseDTO>(environment.eSimApi +
                                               eSimApiPaths.RiskIntelligence + '/' +
                                               eSimApiPaths.RiskIntelligenceLocalRiskLevels,
                                               request)
             .pipe(
               catchError((error) => {
                 return throwError(() => new Error('RisklineLocalRiskLevelsService.getLocalRiskLevels() - ' + this.exceptionsService.formatHttpError(error)));
               })
             );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of({ places: [] });
    }
  }
}
